module.exports = __webpack_public_path__ + "static/media/i_footer_chat.150bf3bb.png";